// @flow
import styled from "styled-components";

import * as colors from "src/styles/constants/colors";
import * as spacing from "src/styles/constants/spacing";

export const MenuItemContainer = styled.div`
  display: ${(props) => (props.display ? props.display : "inline-flex")};
  width: 100%;
  align-items: center;
  justify-content: space-between;
  position: ${(props) => (props.position ? props.position : "initial")};
  cursor: ${(props) => (props.onClick ? "pointer" : "default")};
  height: ${(props) =>
    props.height
      ? (spacing[`space_${props.height}`] ?? props.height)
      : spacing.space_m};
  padding: ${(props) =>
    props.padding
      ? (spacing[`space_${props.padding}`] ?? props.padding)
      : spacing.space_m};
  gap: ${(props) =>
    props.gap ? spacing[`space_${props.gap}`] : spacing.space_m};
  &:hover {
    border-radius: 0px;
    background: ${(props) =>
      props.hoverColor ? props.hoverColor : colors.grey32};
  }
  /*focus has issues getting stuck. Chakra's HStack (used for the Download JSON menu) has its own focus logic.*/
  /*
  &:focus {
    border-radius: 0px;
    background: ${(props) =>
    props.tabIndex === 0
      ? (props.focusColor ?? props.hoverColor ?? colors.grey32)
      : "transparent"};
  }*/
`;
